/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/vue-query';
import { debounce } from 'lodash';
import { ref, Ref, watch } from 'vue';

import objectUtils from '~/utils/objects';

import inactiveAccountsService from '../services/inactiveAccountsService';
import { InactiveAccounts } from "~/types/equipment"

export function useInactiveAccounts(params: Ref<InactiveAccounts.GetInactiveAccountsRequest>) {
  const queryKey = ref(['inactiveAccounts', objectUtils.objectParamsToString(params.value)]);

  const queryFn = async () => {
    const res = await inactiveAccountsService.list({ ...params.value });
    return res;
  };

  const query = useQuery({
    enabled: () => !!params.value.processing_status && !!params.value.competency_month,
    queryFn,
    queryKey,
  });

  const debouncedUpdateQueryKey = debounce((newParams) => {
    queryKey.value = [
      'inactiveAccounts',
      objectUtils.objectParamsToString(newParams),
    ];
  }, 300);

  watch(
    () => params.value,
    (newParams) => {
      debouncedUpdateQueryKey(newParams);
    },
  );

  return query;
}
